import React from "react";
import PageHeader from "../../components/common/PageHeader";
import LatestServiceOffer from "../../components/common/LatestServiceOffer";
import ProductsHeroSection from "../../components/Our Products/ProductsHeroSection";

const ProductsDetail = () => {
  return (
    <div>
      <PageHeader title="Products" />
      <ProductsHeroSection />
      <LatestServiceOffer />
    </div>
  );
};

export default ProductsDetail;
